import * as React from "react";
import DOMPurify from "dompurify";
import styled from "styled-components";
import { useMemo } from "react";
import useNavigationCustomization from "brand-customization/useNavigationCustomization";
import { Icon } from "components/common";
import { MAX_NAV_ICON_WIDTH } from "theme/constants";
const DEFAULT_ICONS = {
  "home": "home",
  "scratchpad": "edit_square",
  "user_menu": "person",
  "help": "help",
  "search": "search"
};
const SvgContainer = styled.div`
  svg {
    width: 100%;
    max-width: ${MAX_NAV_ICON_WIDTH};
    height: 22px;
    display: block;
    fill: currentColor;
  }
`;
const useCustomIcon = (type) => {
  var _a;
  const navigationCustomization = useNavigationCustomization();
  const customIcon = (_a = navigationCustomization == null ? void 0 : navigationCustomization[type]) == null ? void 0 : _a.icon;
  return useMemo(() => {
    if (customIcon) {
      return DOMPurify.sanitize(customIcon);
    }
    return null;
  }, [customIcon]);
};
const NavIcon = ({ type, title = void 0 }) => {
  const customSvgIcon = useCustomIcon(type);
  if (customSvgIcon) {
    return /* @__PURE__ */ React.createElement(SvgContainer, { dangerouslySetInnerHTML: { __html: customSvgIcon }, title });
  }
  return /* @__PURE__ */ React.createElement(Icon, { name: DEFAULT_ICONS[type], size: "lg", title });
};
export default NavIcon;
